import React from 'react';

interface GhostBannerProps {
  impersonatorName?: string;
  targetName?: string;
  onExit?: () => void;
}

const GhostBanner: React.FC<GhostBannerProps> = ({ impersonatorName, targetName, onExit }) => {
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#B91C1C',
        color: '#fff',
        padding: '8px 16px',
        textAlign: 'center',
        fontSize: 12,
        zIndex: 1200,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
        <span>
          You are viewing this account as {targetName || 'a user'}. Actions are being logged.
          {impersonatorName ? ` Impersonator: ${impersonatorName}.` : ''}
        </span>
        {onExit && (
          <button
            type="button"
            onClick={onExit}
            style={{
              backgroundColor: '#FCA5A5',
              color: '#111827',
              border: 'none',
              borderRadius: 4,
              padding: '4px 10px',
              cursor: 'pointer',
            }}
          >
            Exit
          </button>
        )}
      </div>
    </div>
  );
};

export default GhostBanner;
